<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <!-- <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="บริษัท"
                class="ma-2"
              ></v-select> -->
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportDataOT1()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportDataOTFull()"
            >
              Download (ภาพรวม)
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>

          <!-- <v-col cols="6">
            <v-text-field
              v-model="searchAll"
              dense
              outlined
              append-icon="mdi-magnify"
              label="ค้นหา รายชื่อ"
            ></v-text-field>
          </v-col> -->
        </v-row>
        <!-- data table -->
        <v-row>
          <v-col cols="12">
            <v-alert dense type="info" icon="mdi-account-switch">
              <strong>รายการขออนุมัติโอที</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-text-field
                  v-model="searchAll"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="columnsItem"
                  :items="dataItem"
                  :search="searchAll"
                  :items-per-page="10"
                  :loading="!dataReady"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.total_emp_request`]="{ item }">
                    <v-chip dark color="indigo" v-if="item.total_emp != null">
                      {{ item.total_emp }} คน
                    </v-chip>
                    <v-chip v-if="item.total_emp == null"> 0 </v-chip>
                  </template>
                  <template v-slot:[`item.total_draft`]="{ item }">
                    <v-chip
                      dark
                      color="red darken-1"
                      v-if="item.total_draft != null"
                    >
                      {{ item.total_draft }} วัน
                    </v-chip>
                    <v-chip v-if="item.total_draft == null"> 0 </v-chip>
                  </template>
                  <template v-slot:[`item.total_confirm`]="{ item }">
                    <v-chip
                      dark
                      color="deep-orange darken-1"
                      v-if="item.total_confirm != null"
                    >
                      {{ item.total_confirm }} วัน
                    </v-chip>
                    <v-chip v-if="item.total_confirm == null"> 0 </v-chip>
                  </template>
                  <template v-slot:[`item.total_approve`]="{ item }">
                    <v-chip
                      dark
                      color="green darken-1"
                      v-if="item.total_approve != null"
                    >
                      {{ item.total_approve }} / {{ item.count_total }} วัน
                    </v-chip>
                    <v-chip
                      dark
                      color="green darken-1"
                      v-if="item.total_approve == null"
                    >
                      0 / {{ item.count_total }} วัน
                    </v-chip>
                  </template>
                  <template v-slot:[`item.sum_total_hours_approve`]="{ item }">
                    <v-chip
                      dark
                      color="green darken-3"
                      v-if="item.sum_total_hours_approve != null"
                    >
                      {{ item.sum_total_hours_approve }}
                    </v-chip>
                    <v-chip v-if="item.sum_total_hours_approve == null">
                      0
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="info"
                      @click="getOTteam(item), (dialog = true)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>

        <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="90%">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog1()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>ตรวจสอบข้อมูล พนักงาน </v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-col cols="6">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class="white--text"
                @click="exportDataOT2()"
              >
                Download
                <v-icon right dark> mdi-cloud-download </v-icon>
              </v-btn>
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class="white--text"
                @click="getDataReload()"
              >
                reload
                <v-icon right dark> mdi-reload </v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-card elevation="7" v-if="dataReady">
                <v-card-text>
                  <v-card-title>
                    <v-text-field
                      v-model="searchAll2"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="columns"
                    :items="dataItemRequest"
                    :search="searchAll2"
                    :items-per-page="10"
                    :loading="!dataReady"
                    loading-text="Loading... Please wait"
                    class="elevation-1 table-striped table-bordered"
                  >
                    <!-- <template v-slot:[`item.count_total`]="{ item }">
                      <v-chip dark color="indigo">
                      {{item.count_total}} วัน
                      </v-chip>
                    </template> -->
                    <template v-slot:[`item.total_approve`]="{ item }">
                      <v-chip
                        dark
                        color="green"
                        v-if="item.total_approve == item.count_total"
                      >
                        {{ item.total_approve }} / {{ item.count_total }} วัน
                      </v-chip>
                      <v-chip
                        dark
                        color="blue darken-4"
                        v-if="item.total_approve != item.count_total"
                      >
                        {{ item.total_approve }} / {{ item.count_total }} วัน
                      </v-chip>
                    </template>
                    <template
                      v-slot:[`item.SUM_IN_HOURS_AFTER_APPROVE`]="{ item }"
                    >
                      <v-chip
                        dark
                        color="green"
                        v-if="item.sum_total_hours_approve != null"
                      >
                        {{ item.sum_total_hours_approve }}
                      </v-chip>
                      <v-chip v-if="item.sum_total_hours_approve == null"> 0 </v-chip>
                    </template>
                    <template v-slot:[`item.total_confirm`]="{ item }">
                      <v-chip
                        dark
                        color="deep-orange darken-1"
                      >
                        {{ item.total_confirm }} รายการ
                      </v-chip>
                    </template>
                    <template v-slot:[`item.total_draft`]="{ item }">
                      <v-chip
                        dark
                        color="red"
                      >
                        {{ item.total_draft }} รายการ
                      </v-chip>
                      <!-- <v-chip v-if="item.total_confirm == null"> 0 </v-chip> -->
                      <!-- <v-chip
                        dark
                        color="deep-orange darken-1"
                        class="ml-5"
                        v-if="item.sum_hours_confirm != null"
                      >
                        {{ item.sum_hours_confirm }}
                      </v-chip>
                      <v-chip
                        class="ml-5"
                        v-if="item.sum_hours_confirm == null"
                      >
                        0
                      </v-chip> -->
                    </template>
                    <!-- <template v-slot:[`item.SUM_IN_HOURS_AFTER_COMFIRM`]="{ item }">
                      <v-chip dark color="deep-orange darken-1">
                        {{item.sum_hours_confirm}}
                      </v-chip>
                    </template> -->
                    <!-- <template v-slot:[`item.otTime_total`]="{ item }">
                      <v-chip dark color="deep-orange darken-4">
                        {{ item.SUM_TOTAL_IN_HOURS }}
                      </v-chip>
                    </template> -->
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        class="ma-1"
                        color="info"
                        @click="getInfo(item), (dialogDetail = true)"
                      >
                        ตรวจสอบ
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <div v-if="!dataReady" class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
            </v-col>
            <!-- <v-card-actions>
              <v-row class="ma-2" justify="center" align="center">
                <v-chip class="ma-2" color="orange" x-large label outlined>
                  109 นาที / 5 ชั่วโมง
                </v-chip>
              </v-row>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
        <!-- รายละเอียด -->
        <v-dialog v-model="dialogDetail" fullscreen>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title
              >ตรวจสอบข้อมูล รายการคำขอโอทีพนักงาน [<strong>{{
                empFull_NameTH
              }}</strong
              >]</v-toolbar-title
            >
          </v-toolbar>
          <v-card>
            <br />
            <v-col cols="6">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class="white--text"
                @click="exportDataOT3()"
              >
                Download
                <v-icon right dark> mdi-cloud-download </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-toolbar dark color="primary">
                <v-toolbar-title
                  >รายการคำขอโอที สถานะ รอหัวหน้าตรวจสอบ
                </v-toolbar-title>
              </v-toolbar>
            </v-col>

            <v-col cols="12">
              <v-card elevation="7" v-if="dataReady">
                <v-data-table
                  :headers="headersApprove"
                  :items="dessertsDraft"
                  :loading="!dataReady"
                  loading-text="Loading... Please wait"
                  class="elevation-1 table-striped table-bordered"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.ot_before`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_in }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_in }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_before_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_before_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_out }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_out }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_after_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_before`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_before }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_after`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_after }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ item.status }}

                    <!-- <v-chip v-if="status === draft"  color="yellow">
                      {{ item.status }}
                    </v-chip>
                    <v-chip v-if="status === approve" dark color="green">
                      {{ item.status }}
                    </v-chip>
                    <v-chip v-if="status === confirm" dark color="orange">
                      {{ item.status }}
                    </v-chip> -->
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-toolbar dark color="primary">
                <v-toolbar-title
                  >รายการคำขอโอที สถานะ รอฝ่ายบุคคลตรวจสอบ
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <v-card elevation="7" v-if="dataReady">
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="desserts"
                  :single-select="singleSelect"
                  item-key="ot_day"
                  show-select
                  :loading="!dataReady"
                  loading-text="Loading... Please wait"
                  class="elevation-1 table-striped table-bordered"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.ot_before`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_in }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_in }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_before_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_before_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_before`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_before }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_after`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_after }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_out }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_out }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_after_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      class="mr-5"
                      @click="getEditItem(item), (dialogEditOT = true)"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="desserts.length > 0 && selected.length > 0"
                elevation="2"
                x-large
                color="success"
                text
                @click="updateStatus(selected, 'approve')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                v-if="desserts.length > 0 && selected.length > 0"
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="getDataReject(selected)"
              >
                <v-icon left> mdi-minus-circle-outline</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                v-if="desserts.length > 0 && selected.length > 0"
                elevation="2"
                x-large
                color="red"
                text
                @click="updateStatus(selected, 'cancel')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>

            <v-dialog v-model="dialogReject" persistent max-width="600px">
              <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                  <span class="headline">หมายเหตุ ยกเลิก</span>
                  <v-col class="text-right pb-0 pt-0 pr-0">
                    <v-icon color="#173053" @click="dialogReject = false"
                      >mdi-close-circle</v-icon
                    >
                  </v-col>
                </v-card-title>
                <v-card-text class="pa-4 pb-0">
                  <v-textarea
                    v-model="formUpdate.otDetail"
                    maxlength="100"
                    rows="3"
                    row-height="25"
                    outlined
                    clearable
                    clear-icon="mdi-close-circle"
                    label="หมายเหตุ"
                  ></v-textarea>
                </v-card-text>
                <v-card-actions class="pa-2 ma-2 mt-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    color="red"
                    elevation="2"
                    @click="updateStatusReject(formUpdate, 'reject')"
                  >
                    ยกเลิก
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-col cols="12">
              <v-toolbar dark color="primary">
                <v-toolbar-title
                  >รายการคำขอโอที สถานะ อนุมัติ
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <v-card elevation="7" v-if="dataReady">
                <v-data-table
                  v-model="selected"
                  :headers="headersApprove"
                  :items="dessertsApprove"
                  :single-select="singleSelect"
                  item-key="ot_day"
                  show-select
                  :loading="!dataReady"
                  loading-text="Loading... Please wait"
                  class="elevation-1 table-striped table-bordered"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.ot_before`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_in }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_in }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_before_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_before_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_out }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_out }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_after_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_before`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_before }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.request_ot_time_after`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.request_ot_time_after }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ item.status }}

                    <!-- <v-chip v-if="status === draft"  color="yellow">
                      {{ item.status }}
                    </v-chip>
                    <v-chip v-if="status === approve" dark color="green">
                      {{ item.status }}
                    </v-chip>
                    <v-chip v-if="status === confirm" dark color="orange">
                      {{ item.status }}
                    </v-chip> -->
                  </template>
                </v-data-table>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="selected.length > 0"
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="getDataBackward(selected)"
                >
                  <v-icon left> mdi-backup-restore</v-icon>
                  แก้ไขสถานะ
                </v-btn>
                <v-btn
                  v-if="selected.length > 0"
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="getDataReject(selected)"
                >
                  <v-icon left> mdi-minus-circle-outline</v-icon>
                  ยกเลิก
                </v-btn>
                <v-btn
                  v-if="selected.length > 0"
                  elevation="2"
                  x-large
                  color="red"
                  text
                  @click="updateStatus(selected, 'cancel')"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ไม่อนุมัติ
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-toolbar dark color="primary">
                <v-toolbar-title
                  >รายการคำขอโอที สถานะ ยกเลิก
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <v-card elevation="7" v-if="dataReady">
                <v-data-table
                  v-model="selected"
                  :headers="headersApprove"
                  :items="dessertsUnApprove"
                  :single-select="singleSelect"
                  item-key="ot_day"
                  show-select
                  :loading="!dataReady"
                  loading-text="Loading... Please wait"
                  class="elevation-1 table-striped table-bordered"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.ot_before`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_in }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_in }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_before_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_before_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after`]="{ item }">
                    <v-chip dark color="orange">
                      {{ item.shift_check_out }}
                    </v-chip>
                    <v-chip dark color="green">
                      {{ item.check_out }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.ot_after_cal`]="{ item }">
                    <v-chip dark color="#B388FF">
                      {{ item.ot_time_after_calculate }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ item.status }}
                  </template>
                </v-data-table>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="selected.length > 0"
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="getDataBackward(selected)"
                >
                  <v-icon left> mdi-backup-restore</v-icon>
                  แก้ไขสถานะ
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEditOT" width="500">
          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              แก้ไขจำนวนเวลาที่ได้โอที <v-spacer></v-spacer>
              <strong>
                วันที่ : {{ dateItemInfo.ot_day }}-{{
                  dateItemInfo.ot_month
                }}-{{ dateItemInfo.ot_year }}</strong
              >
            </v-card-title>

            <v-row class="pa-2 ma-2">
              <v-col cols="6">
                <v-select
                  :items="itemsTime"
                  v-model="dateItemInfo.ot_time_before_calculate"
                  clearable
                  clear-icon="mdi-close-circle"
                  outlined
                  dense
                  label="เวลาที่จะให้โอทีเช้า"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="itemsTime"
                  v-model="dateItemInfo.ot_time_after_calculate"
                  clearable
                  clear-icon="mdi-close-circle"
                  outlined
                  dense
                  label="เวลาที่จะให้โอทีบ่าย"
                ></v-select>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editRequestOT(dateItemInfo)">
                บันทึกการแก้ไข
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      path: '/ot_request/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการขอโอที',
          disabled: false,
          href: '/HRM/Overtime/OTDataRequest'
        }
      ],
      session: this.$session.getAll(),
      loading: false,
      loading2: false,
      dataReady: true,
      dialog: false,
      dialogDetail: false,
      dialogEditOT: false,
      singleSelect: false,
      selected: [],
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: (v) => v.length <= 50 || 'Input too long!',
      pagination: {},
      headers: [
        {
          text: 'วันที่',
          align: 'start',
          sortable: false,
          value: 'ot_day'
        },
        { text: 'เวลาที่ทำโอทีก่อนเข้างาน', value: 'ot_before', width: '150' },
        { text: 'เช้า', value: 'ot_before_check_in_status' },
        // { text: 'จำนวนล่วงเวลา', value: 'before_check_in_minute', width: '120' },
        { text: 'จำนวนที่ขอ', value: 'request_ot_time_before', width: '150' },
        { text: 'จำนวนเวลาที่ได้โอทีก่อนเข้างาน', value: 'ot_before_cal', width: '150' },
        { text: 'เวลาที่ขอโอทีหลังเลิกงาน', value: 'ot_after', width: '150' },
        { text: 'เย็น', value: 'ot_after_check_out_status' },
        // { text: 'จำนวนล่วงเวลา', value: 'after_check_out_minute', width: '120' },
        { text: 'จำนวนที่ขอ', value: 'request_ot_time_after', width: '150' },
        { text: 'จำนวนเวลาที่ได้โอทีหลังเลิกงาน', value: 'ot_after_cal', width: '150' },
        { text: 'หมายเหตุ', value: 'otRemark', width: '150' },
        { text: 'วันที่ทำรายการ', value: 'CREATE_DATE' },
        { text: 'แก้ไข', value: 'actions', sortable: false }
      ],
      desserts: [],
      headersApprove: [
        {
          text: 'วันที่',
          align: 'start',
          sortable: false,
          value: 'ot_day'
        },
        { text: 'เวลาที่ทำโอทีก่อนเข้างาน', value: 'ot_before', width: '150' },
        { text: 'เช้า', value: 'ot_before_check_in_status' },
        // { text: 'จำนวนล่วงเวลา', value: 'before_check_in_minute', width: '120' },
        { text: 'จำนวนที่ขอ', value: 'request_ot_time_before', width: '150' },
        { text: 'จำนวนเวลาที่ได้โอทีก่อนเข้างาน', value: 'ot_before_cal', width: '150' },
        { text: 'เวลาที่ขอโอทีหลังเลิกงาน', value: 'ot_after', width: '150' },
        { text: 'เย็น', value: 'ot_after_check_out_status' },
        // { text: 'จำนวนล่วงเวลา', value: 'after_check_out_minute', width: '120' },
        { text: 'จำนวนที่ขอ', value: 'request_ot_time_after', width: '150' },
        { text: 'จำนวนเวลาที่ได้โอทีหลังเลิกงาน', value: 'ot_after_cal', width: '150' },
        { text: 'หมายเหตุ', value: 'otRemark', width: '150' },
        { text: 'วันที่ทำรายการ', value: 'CREATE_DATE' },
        { text: 'สถานะ', value: 'status' }
      ],
      dessertsApprove: [],
      dessertsUnApprove: [],
      dessertsDraft: [],
      columns: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          sortable: false,
          value: 'empCode'
        },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        // {
        //   text: 'จำนวนวันที่ขอ',
        //   value: 'count_total'
        // },
        {
          text: 'จำนวนวันที่รอหัวหน้า',
          value: 'total_draft'
        },
        {
          text: 'จำนวนวันที่รอฝ่ายบุคคลตรวจสอบ',
          value: 'total_confirm'
        },
        // {
        //   text: 'จำนวนโอทีที่รอฝ่ายบุคคลตรวจสอบ',
        //   value: 'SUM_IN_HOURS_AFTER_COMFIRM'
        // },
        {
          text: 'จำนวนวันที่อนุมัติ',
          value: 'total_approve'
        },
        {
          text: 'โอทีรวมที่อนุมัติ',
          value: 'SUM_IN_HOURS_AFTER_APPROVE'
        },
        // {
        //   text: 'รวมโอที',
        //   value: 'otTime_total'
        // },
        {
          text: ' ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItemRequest: [],
      headersApproveDialog: [],
      itemsTime: [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00'
      ],
      columnsItem: [
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' },
        { text: 'แผนก', value: 'masDepartmentName_approve' },
        { text: 'สาขา', value: 'masBranchName_approve' },
        {
          text: 'จำนวนพนักงาน',
          value: 'total_emp_request',
          sortable: false,
          align: 'center'
        },
        {
          text: 'จำนวนวันที่รอหัวหน้า',
          value: 'total_draft',
          sortable: false,
          align: 'center'
        },
        {
          text: 'จำนวนวันที่รอฝ่ายบุคคล',
          value: 'total_confirm',
          sortable: false,
          align: 'center'
        },
        // {
        //   text: 'จำนวนวันที่อนุมัติแล้ว',
        //   value: 'total_approve',
        //   sortable: false,
        //   align: 'center'
        // },
        { text: 'รวมโอทีที่อนุมัติ', value: 'sum_total_hours_approve' },
        {
          text: 'ตรวจสอบ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem: [],
      dateItemInfo: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      month: '',
      day: '',
      empFull_NameTH: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      dialogReject: false,
      searchAll2: '',
      formUpdate: [],
      otDetail: '',
      countTime: 0
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getData()

    // await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async getData () {
      await this.getDataWaiting()
      // await this.getOTteam()
    },
    async getDataWaiting () {
      this.dataReady = false
      this.dataItem = []

      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null

      var monthSearch =
        this.month !== null
          ? '?ot_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null
          ? '&masDepartmentName_approve=' + this.Department
          : ''
      var Branch =
        this.Branch !== null ? '&masBranchName_approve=' + this.Branch : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/getHeader' +
            monthSearch +
            '&ot_year=' +
            this.year +
            Department +
            Branch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItem = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getOTteam (item) {
      this.dataReady = false
      this.dataItemRequest = []
      this.headersApproveDialog = item
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null
      this.empCodeApprove = this.empCodeApprove ? this.empCodeApprove : null

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''
      var headApprove =
        item.empCodeApprove !== null
          ? '&empCodeApprove=' + item.empCodeApprove
          : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/getEmpByHeader' +
            '?ot_year=' +
            this.year +
            monthSearch +
            headApprove +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemRequest = response.data
          }
          this.dataReady = true
        })
    },
    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    getEditItem (itemdata) {
      this.dateItemInfo = []
      this.dateItemInfo = itemdata
    },
    async editRequestOT (item) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ยืนยันข้อมูลโอทีทั้งหมด ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        var ID = item.otID
        let dt = {
          ot_time_after_calculate: item.ot_time_after_calculate,
          ot_time_before_calculate: item.ot_time_before_calculate,
          ot_after_check_out_status: item.ot_after_check_out_status,
          ot_before_check_in_status: item.ot_before_check_in_status,
          otRemark: item.otRemark,
          LAST_USER: this.$session.getAll().data.userName
        }
        let formLog = {
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName,
          empCode: this.profile.empCode,
          shiftCode: item.shiftCode,
          ot_before_check_in_status: item.ot_before_check_in_status,
          ot_after_check_out_status: item.ot_after_check_out_status,
          shift_check_in: item.shift_check_in,
          check_in: item.check_in,
          before_check_in_minute: item.before_check_in_minute,
          shift_check_out: item.shift_check_out,
          check_out: item.check_out,
          after_check_out_minute: item.after_check_out_minute,
          ot_year: item.ot_year,
          ot_month: item.ot_month,
          ot_day: item.ot_day,
          ot_date: item.ot_date,
          status: 'approve',
          otRemark: item.otRemark,
          request_ot_time_after: item.request_ot_time_after,
          request_ot_time_before: item.request_ot_time_before,
          ot_time_after_calculate: item.ot_time_after_calculate,
          ot_time_before_calculate: item.ot_time_before_calculate,
          otDetail: item.otDetail,
          ot_request_late: 'edit_by_hr'
        }

        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/ot_request/edit_ot/" + ID,
            dt,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + '/ot_request/add_log',
            formLog
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'แก้ไขข้อมูลเรียบร้อย', 'success')
            this.dialogEditOT = false
            this.dataReady = true
          })
      })
    },
    getDataReject (item) {
      this.formUpdate = []
      this.dialogReject = true
      this.formUpdate = item
      this.formUpdate.otDetail = '-'
    },
    getDataBackward (selected) {
      this.updateStatus(selected, 'confirm')
    },
    async updateStatusReject (formUpdate, status) {
      this.dataReady = false
      this.$swal({
        title: 'ท่านต้องการ ยกเลิกคำขอโอที ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false
          await this.selected.forEach(async (element) => {
            let ds = {
              otID: element.otID,
              status: status,
              otDetail: formUpdate.otDetail,
              LAST_UPDATE_GA: moment().format('YYYY-MM-DD'),
              LAST_USER: this.session.data.userName
            }
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/ot_request/updateRejectByGA",
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async (response) => {
                this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
                this.selected = []
                this.dialogReject = false
                this.dataReady = true
                this.shift_import_team()
                this.shift_import_team_approve()
                this.shift_import_team_unapprove()
                this.shift_import_team_draft()
                this.dataReady = false
              })
          })
        })
        .catch((error) => {
          this.dataReady = false
          this.shift_import_team()
          this.shift_import_team_approve()
          this.shift_import_team_unapprove()
          this.shift_import_team_draft()
          console.log(error)
        })
    },
    async updateStatus (item, status) {
      this.dataReady = false
      var statusName =
        status === 'approve'
          ? 'อนุมัติ'
          : status === 'cancel'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false
          await this.selected.forEach(async (element) => {
            let ds = {
              otID: element.otID,
              status: status,
              LAST_UPDATE_GA: moment().format('YYYY-MM-DD'),
              LAST_USER: this.session.data.userName
            }
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/ot_request/updateByGA",
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async (response) => {
                this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
                // this.dialogView = false
                this.selected = []
                this.dataReady = true
                this.shift_import_team()
                this.shift_import_team_approve()
                this.shift_import_team_unapprove()
                this.shift_import_team_draft()
                this.dataReady = false
                // this.getInfo()
                // this.dataReady = false
              })
          })
        })
        .catch((error) => {
          this.dataReady = false
          this.shift_import_team()
          this.shift_import_team_approve()
          this.shift_import_team_unapprove()
          this.shift_import_team_draft()
          console.log(error)
        })
    },
    getInfo (item) {
      this.profile = item
      this.empFull_NameTH = this.profile.empFull_NameTH
      this.shift_import_team()
      this.shift_import_team_approve()
      this.shift_import_team_unapprove()
      this.shift_import_team_draft()
    },
    closeDialog () {
      this.dataReady = true
      this.getOTteam(this.headersApproveDialog)
      this.dialogDetail = false
    },
    getDataReload () {
      this.dataReady = true
      this.getOTteam(this.headersApproveDialog)
      this.dataReady = false
    },
    closeDialog1 () {
      this.dataReady = true
      this.getDataWaiting()
      this.dialog = false
    },
    async shift_import_team () {
      this.dataReady = false
      this.desserts = []

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      var url =
        '/ot_request/getOTByEmpCode?empCode=' +
        this.profile.empCode +
        '&ot_month=' +
        monthSearch +
        '&ot_year=' +
        this.year

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          if (response.data) {
            this.desserts = response.data
          }
          this.dataReady = true
        })
    },
    async shift_import_team_approve () {
      this.dataReady = false
      this.dessertsApprove = []

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      var url =
        '/ot_request/getapprove?empCode=' +
        this.profile.empCode +
        '&ot_month=' +
        monthSearch +
        '&ot_year=' +
        this.year

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          if (response.data) {
            this.dessertsApprove = response.data
          }
          this.dataReady = true
        })
    },
    async shift_import_team_unapprove () {
      this.dataReady = false
      this.dessertsUnApprove = []

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      var url =
        '/ot_request/getunapprove?empCode=' +
        this.profile.empCode +
        '&ot_month=' +
        monthSearch +
        '&ot_year=' +
        this.year

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          if (response.data) {
            this.dessertsUnApprove = response.data
          }
          this.dataReady = true
        })
    },
    async shift_import_team_draft () {
      this.dataReady = false
      this.dessertsDraft = []

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      var url =
        '/ot_request/getDraft?empCode=' +
        this.profile.empCode +
        '&ot_month=' +
        monthSearch +
        '&ot_year=' +
        this.year

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          if (response.data) {
            this.dessertsDraft = response.data
          }
          this.dataReady = true
        })
    },
    async clear () {
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      this.leaveType = ''
      await this.getData()
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async exportDataOT1 () {
      var tem = []
      this.dataItem.forEach((element) => {
        let s = {
          รหัสหัวหน้า: element.empCodeApprove,
          ชื่อหัวหน้า: element.empFull_NameTH_approve,
          แผนก: element.masDepartmentName_approve,
          สาขา: element.masBranchName_approve,
          'จำนวนพนักงาน/คน': element.total_emp,
          'จำนวนที่รอหัวหน้า/วัน': element.total_draft,
          'จำนวนที่รอฝ่ายบุคคล/วัน': element.total_confirm,
          'จำนวนวันที่อนุมัติแล้ว/วัน': element.total_approve,
          'จำนวนวันที่ขอทั้งหมด/วัน': element.count_total,
          รวมโอทีที่อนุมัติ: element.sum_total_hours_approve
        }
        tem.push(s)
      })
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      XLSX.writeFile(
        wb,
        'ข้อมูลโอที(' + this.month + ' ' + this.year + ').xls'
      ) // name of the file is 'book.xlsx'
    },
    async exportDataOT2 () {
      var tem = []
      this.dataItemRequest.forEach((element) => {
        let s = {
          รหัสหัวหน้า: element.empCodeApprove,
          หัวหน้า: element.empFull_NameTH_approve,
          วันที่: element.ot_month + '-' + element.ot_year,
          รอฝ่ายบุคคลตรวจสอบ: element.total_confirm,
          จำนวนโอทีที่รอตรวจสอบ: element.sum_hours_confirm,
          จำนวนวันที่อนุมัติแล้ว: element.total_approve,
          จำนวนวันที่ขอทั้งหมด: element.count_total,
          รวมโอทีที่อนุมัติแล้ว: element.sum_hours_approve,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName
        }
        tem.push(s)
      })
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      XLSX.writeFile(
        wb,
        'ข้อมูลโอที ภายใต้การอนุมัติของ (' +
          ' ' +
          this.month +
          ' ' +
          this.year +
          ').xls'
      ) // name of the file is 'book.xlsx'
    },
    async exportDataOT3 () {
      var tem1 = []
      var tem2 = []
      var tem3 = []
      var tem4 = []
      this.desserts.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          วันที่: element.ot_date,
          เวลาที่ทำโอทีก่อนเข้างาน:
            element.shift_check_in + '-' + element.check_in,
          จำนวนเวลาที่ได้โอทีก่อนเข้างาน: element.ot_time_before_calculate,
          เวลาที่ขอโอทีหลังเลิกงาน:
            element.shift_check_out + '-' + element.check_out,
          จำนวนเวลาที่ได้โอทีหลังเลิกงาน: element.ot_time_after_calculate,
          หมายเหตุ: element.otRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.status
        }
        tem1.push(s)
      })
      this.dessertsApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          วันที่: element.ot_date,
          เวลาที่ทำโอทีก่อนเข้างาน:
            element.shift_check_in + '-' + element.check_in,
          จำนวนเวลาที่ได้โอทีก่อนเข้างาน: element.ot_time_before_calculate,
          เวลาที่ขอโอทีหลังเลิกงาน:
            element.shift_check_out + '-' + element.check_out,
          จำนวนเวลาที่ได้โอทีหลังเลิกงาน: element.ot_time_after_calculate,
          หมายเหตุ: element.otRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.status
        }
        tem2.push(s)
      })
      this.dessertsUnApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          วันที่: element.ot_date,
          เวลาที่ทำโอทีก่อนเข้างาน:
            element.shift_check_in + '-' + element.check_in,
          จำนวนเวลาที่ได้โอทีก่อนเข้างาน: element.ot_time_before_calculate,
          เวลาที่ขอโอทีหลังเลิกงาน:
            element.shift_check_out + '-' + element.check_out,
          จำนวนเวลาที่ได้โอทีหลังเลิกงาน: element.ot_time_after_calculate,
          หมายเหตุ: element.otRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.status
        }
        tem3.push(s)
      })
      this.dessertsDraft.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          วันที่: element.ot_date,
          เวลาที่ทำโอทีก่อนเข้างาน:
            element.shift_check_in + '-' + element.check_in,
          จำนวนเวลาที่ได้โอทีก่อนเข้างาน: element.ot_time_before_calculate,
          เวลาที่ขอโอทีหลังเลิกงาน:
            element.shift_check_out + '-' + element.check_out,
          จำนวนเวลาที่ได้โอทีหลังเลิกงาน: element.ot_time_after_calculate,
          หมายเหตุ: element.otRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.status
        }
        tem4.push(s)
      })
      var data = XLSX.utils.json_to_sheet(tem1)
      var approve = XLSX.utils.json_to_sheet(tem2)
      var unapprove = XLSX.utils.json_to_sheet(tem3)
      var dataDraft = XLSX.utils.json_to_sheet(tem4)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, dataDraft, 'รอหัวหน้าตรวจสอบ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, data, 'รอฝ่ายบุคคลตรวจสอบ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'รายการอนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'รายการยกเลิก')
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(wb, 'รายการคำขอโอที(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    },
    async exportDataOTFull () {
      this.dataReady = false
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null

      var monthSearch =
        this.month !== null
          ? '?ot_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null
          ? '&masDepartmentName_approve=' + this.Department
          : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/get' +
            monthSearch +
            '&ot_year=' +
            this.year +
            Department
        )
        .then(async (response) => {
          if (response.data.length) {
            this.dataReady = true
            console.log(response.data)
            var tem1 = []
            response.data.forEach((element) => {
              let s = {
                รหัสพนักงาน: element.empCode,
                ชื่อพนักงาน: element.empFull_NameTH,
                แผนก: element.masDepartmentName,
                สาขา: element.masBranchName,
                วันที่: element.ot_date,
                กะเข้างาน: element.shift_check_in,
                เวลาเข้างาน: element.check_in,
                จำนวนล่วงเวลาเข้างาน: element.before_check_in_minute,
                สเตตัสขอโอทีเข้างาน: element.ot_before_check_in_status,
                จำนวนที่ขอโอทีเข้างาน: element.request_ot_time_before,
                จำนวนเวลาที่ได้โอทีเข้างาน: element.ot_time_before_calculate,

                กะออกงาน: element.shift_check_out,
                เวลาที่ออกงาน: element.check_out,
                จำนวนล่วงเวลาออกงาน: element.after_check_out_minute,
                สเตตัสขอโอทีออกงาน: element.ot_after_check_out_status,
                จำนวนที่ขอโอทีออกงาน: element.request_ot_time_after,
                จำนวนเวลาที่ได้โอทีออกงาน: element.ot_time_after_calculate,

                หมายเหตุ: element.otRemark,
                วันที่ทำรายการ: element.CREATE_DATE,
                สถานะ: element.status
              }
              tem1.push(s)
            })
            var data = XLSX.utils.json_to_sheet(tem1)
            var wb = XLSX.utils.book_new() // make Workbook of Excel
            XLSX.utils.book_append_sheet(wb, data, 'รอหัวหน้าตรวจสอบ')
            this.month = this.getMonthTh()
            let date = new Date()
            this.year = moment().format('YYYY')
            this.day = date.getDate()
            XLSX.writeFile(wb, 'รายการคำขอโอที(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
          } else {
            console.log('ไม่เจอข้อมูลนะ')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    }
  }
}
</script>
<style scope>
:root {
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Overtime/OTDataRequest.vue